import { fetchJson } from '@frontend/store/fetch';

export async function fetchPractitionerEmployments(
    abortSignal: AbortSignal
): Promise<{ id: string; organization: { id: string } }[]> {
    const response = await fetchJson({
        method: 'GET',
        signal: abortSignal,
        url: `/api/user/employments`,
    });

    return response.json.items;
}
